import React from 'react';

const Contact = () => {
  return (
    <section id="contact">
      <div className="container">
        <h2 className="section-title">Informasi Lebih Lanjut</h2>
        <div className="contact">
          <h3>Hubungi Kami</h3>
          <p>Untuk informasi selanjutnya, silahkan kirimkan pesan ke WhatsApp kami:</p>
          <a 
            href="https://wa.me/62811248168" 
            className="whatsapp-button" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <i className="fab fa-whatsapp"></i> DAFTAR SEKARANG
          </a>
        </div>
      </div>
    </section>
  );
};

export default Contact;
